import { useEffect, useState } from "react";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { useNavigate, useParams } from "react-router-dom";
import {
  Fade,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import DocumentIcon from "../../components/Icons/DocumentIcon";
import ViewDocumentModal from "./ViewDocumentModal";
import MapComponent from "../../components/comman/MapComponent";
import PlusIcon from "../../components/Icons/PlusIcon";
import FilterComponent from "../../components/comman/FilterComponent";
import { useRef } from "react";
import CommonTable from "../../components/comman/CommonTable";
import { MainFilterHandler } from "../../components/comman/MainFilterHandler";
import ViewIcon from "../../components/Icons/ViewIcon";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import AddTeamModal from "./AddTeamModal";
import { useDispatch, useSelector } from "react-redux";
import { saveActiveSiteDetailTab } from "../../store/actions/UserActions";
import calculateFinancialYears, { checkUserAccess, formatAmount } from "../../utility/CommonFunctions";
import { toast } from "react-toastify";
import ConfirmModal from "../../components/comman/ConfirmModal";
import TeamTree from "../../components/comman/TeamTree";
import EditIcon from "../../components/Icons/EditIcon";
import BgBlurLoader from "../../components/Loaders/BgBlurLoader";
import NoRecordIcon from "../../components/Icons/NoRecordIcon";
import moment from "moment";
import MainHeading from "../../components/comman/MainHeading";
import ExportDataHandler from "../../utility/ExportDataHandler";
import FreezedAmountDetailModal from "./FreezedAmountDetailModal";

const ExpandableDescription = ({ text, onReadMore }) => {
  if (!text) return <span className="text-secondary fs-5">--</span>;

  const isLong = text.length > 120;

  if (!isLong) {
    return <span className="text-secondary fs-5" style={{ whiteSpace: 'pre-wrap' }}>{text}</span>;
  }

  return (
    <div title={text}>
      <div
        className="text-secondary fs-5"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'pre-wrap'
        }}
      >
        {text}
      </div>
      <span
        className="text-primary fs-5 fw-bold mt-1 d-inline-block"
        style={{ cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation();
          onReadMore(text);
        }}
      >
        Read more
      </span>
    </div>
  );
};

export default function SiteDetail() {
  let { id } = useParams();
  const timeoutId = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ActiveTab = useSelector((state) => state?.root?.activeSiteDetailTab);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [isFreezedModalOpen, setIsFreezedModalOpen] = useState(false);
  const toggleFreezedModal = () => setIsFreezedModalOpen(!isFreezedModalOpen);
  const [selectedFreezedItem, setSelectedFreezedItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const [selectedId, setSelectedId] = useState("");
  const apiKey = import.meta.env.VITE_APP_API_KEY;
  const [mapCenter, setMapCenter] = useState({ lat: 28.0229, lng: 73.3119 });
  const [markers, setMarkers] = useState([{ lat: 28.0229, lng: 73.3119 }]);
  const [circleRadius, setCircleRadius] = useState(0);
  const [addTeamModal, setAddTeamModal] = useState(false);
  const toggleAddTeamModal = () => setAddTeamModal(!addTeamModal);
  const [descModal, setDescModal] = useState({ isOpen: false, text: "" });
  const toggleDescModal = () => setDescModal({ ...descModal, isOpen: !descModal.isOpen });
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState("0");
  const toggle = (id) => {
    setOpen(open === id ? "" : id);
  };
  const [nestedOpen, setNestedOpen] = useState({ 0: "0" });

  const toggleNested = (budgetIndex, itemIndex) => {
    setNestedOpen((prev) => ({
      ...prev,
      [budgetIndex]:
        prev[budgetIndex] === itemIndex.toString() ? "" : itemIndex.toString(),
    }));
  };

  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    siteDetail: [],
    siteUsersList: [],
    siteTeamList: [],
    searchQuery: "",
    loadingProfile: false,
    loadingBudget: false,
    loadingSiteDetail: false,
    financialYears: [],
    activeFinancialYear: "",
  });

  const [budgetSection, setBudgetSection] = useState([
    {
      heading: "Supply Budget",
      type: "supplyBudget",
      budgetItems: [],
      budgetTotal: 0,
      freezedBudgetTotal: 0,
      remainingBudgetTotal: 0,
    },
    {
      heading: "Service Budget",
      type: "serviceBudget",
      budgetItems: [],
      budgetTotal: 0,
      freezedBudgetTotal: 0,
      remainingBudgetTotal: 0,
    },
    {
      heading: "Staff Budget",
      type: "staffBudget",
      budgetItems: [],
      budgetTotal: 0,
      freezedBudgetTotal: 0,
      remainingBudgetTotal: 0,
    },
    {
      heading: "General Budget",
      type: "generalBudget",
      budgetItems: [],
      budgetTotal: 0,
      freezedBudgetTotal: 0,
      remainingBudgetTotal: 0,
    },
  ]);

  const userDetails = useSelector((state) => state.root.userDetails);
  const toggleTab = (tab) => {
    dispatch(saveActiveSiteDetailTab(tab));
    if (
      tab === 2 &&
      budgetSection?.slice(0, 4)?.every((item) => item?.budgetTotal === 0)
    ) {
      fetchBudgetData();
    }
  };

  useEffect(() => {
    GetSiteDetail();
  }, []);

  useEffect(() => {
    GetSiteTeam();
    if (ActiveTab == 2 && pageStates?.activeFinancialYear) {
      fetchBudgetData();
    }
    if (ActiveTab == 4 && pageStates?.activeFinancialYear) {
      fetchBudgetAnalyticsData();
    }
  }, [pageStates?.activeFinancialYear, ActiveTab]);

  const [budgetAnalyticsSummary, setBudgetAnalyticsSummary] = useState(null);
  const [budgetAnalyticsHeads, setBudgetAnalyticsHeads] = useState([]);
  const [budgetFilter, setBudgetFilter] = useState("All");

  const fetchBudgetAnalyticsData = async () => {
    setPageStates((prev) => ({ ...prev, loadingBudget: true }));
    const url = apiUrl.get_site_budget_analytics + `siteId=${id}&financialYear=${pageStates?.activeFinancialYear}`;
    callApi(url, { method: "GET" })
      .then((res) => {
        setPageStates((prev) => ({ ...prev, loadingBudget: false }));
        if (res?.status) {
          setBudgetAnalyticsSummary(res?.data?.summary);
          setBudgetAnalyticsHeads(res?.data?.heads || []);
        } else {
          setBudgetAnalyticsSummary(null);
          setBudgetAnalyticsHeads([]);
        }
      })
      .catch((error) => {
        setPageStates((prev) => ({ ...prev, loadingBudget: false }));
      });
  };



  const [budgetSummary, setBudgetSummary] = useState(null);

  const fetchBudgetData = async () => {
    // Fetch budgets in parallel
    const updatedBudgetSections = await Promise.all(
      budgetSection.map(async (item) => {
        const res = await GetSiteBudget(item.type);
        let newGrandTotal = 0;
        let newFreezedTotal = 0;
        res?.data?.forEach((expense) => {
          newGrandTotal += parseFloat(expense.expectedAmount || "0");
          newFreezedTotal += Math.max(parseFloat(expense.freezedAmount || "0"), parseFloat(expense.cashflowAmount || "0"));
        });
        return {
          ...item,
          budgetItems: res?.data || [],
          budgetTotal: newGrandTotal,
          freezedBudgetTotal: newFreezedTotal,
          remainingBudgetTotal: newGrandTotal - newFreezedTotal,
        };
      })
    );

    setBudgetSection(updatedBudgetSections);
  };

  // printData("Budget", budgetSection)

  useEffect(() => {
    GetSiteUserList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates.pageSize]);

  useEffect(() => {
    if (pageStates?.siteDetail?.location) {
      const locationData =
        typeof pageStates?.siteDetail?.location === "string"
          ? JSON.parse(pageStates?.siteDetail?.location)
          : pageStates?.siteDetail?.location;

      if (locationData?.lat && locationData?.lng) {
        const latitude = parseFloat(locationData.lat);
        const longitude = parseFloat(locationData.lng);
        const range = parseFloat(pageStates?.siteDetail?.range);

        setMapCenter({ lat: latitude, lng: longitude });
        setMarkers([{ lat: latitude, lng: longitude }]);
        setCircleRadius(range);
      }
    }
  }, [pageStates?.siteDetail?.location]);

  const GetSiteBudget = (type) => {
    setPageStates((prev) => ({
      ...prev,
      loadingBudget: true,
    }));
    const url = apiUrl.get_site_budget + `type=${type}&siteId=${id}&financialYear=${pageStates?.activeFinancialYear}`;

    return callApi(url, { method: "GET" })
      .then((res) => {
        setPageStates((prev) => ({
          ...prev,
          loadingBudget: false,
        }));
        if (res?.status) {
          return res;
        }
        return { data: [] };
      })
      .catch((error) => {
        console.error("Error fetching budget:", error);
        return { data: [] };
      });
  };

  const GetSiteDetail = () => {
    let options = {
      method: "GET",
    };
    setPageStates((prev) => ({
      ...prev,
      loadingSiteDetail: true,
    }));
    let API = apiUrl.get_site + `?siteId=${id}`;
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingSiteDetail: false,
      }));
      if (response?.status === true) {
        const site = response?.data?.site?.[0] || {};
        const startDate = site?.startDate;
        const endDate = site?.endDate;
        const now = moment();
        const month = now.month() + 1;
        const year = now.year();
        const fyStartYear = month >= 4 ? year : year - 1;
        const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

        if (!startDate || !endDate) {
          setPageStates((prevStates) => ({
            ...prevStates,
            siteDetail: site,
            financialYears: [currentFY],
            activeFinancialYear: currentFY,
          }));
          return;
        }

        const fys = calculateFinancialYears(
          moment.utc(startDate).format("YYYY-MM-DD"),
          moment.utc(endDate).format("YYYY-MM-DD")
        );

        const defaultFY = fys.includes(currentFY) ? currentFY : fys[0] || "";

        setPageStates((prevStates) => ({
          ...prevStates,
          siteDetail: site,
          financialYears: fys,
          activeFinancialYear: defaultFY || currentFY,
        }));
      }
    });
  };


  const GetSiteTeam = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_team + `?siteId=${id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prevStates) => ({
          ...prevStates,
          siteTeamList: response?.data,
        }));
      }
    });
  };

  const GetSiteUserList = (pageNumber) => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.site_users + "?" + MainFilterHandler(pageStates) + `&siteId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.user?.map((item) => ({
          ...item,
          empName: item?.user?.name || "--",
          empDept: item?.user?.department?.name || "--",
          empDesignation: item?.user?.designation?.name || "--",
          phone: item?.user?.phone || "--",
          shift: item?.user?.Shift?.shiftName || "--",
          status: item?.user?.status,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          siteUsersList: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleViewUser = (data) => {
    navigate(`${RoutesLink?.employee_detail}/${data?.user?.id}`);
  };

  const DeleteActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleDeleteModal();
  };

  const handleDeleteTeamMember = () => {
    let options = {
      method: "GET",
    };
    setIsLoading(true);
    let API = apiUrl.delete_team + `?teamId=${selectedId}`;
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        GetSiteTeam();
        toggleDeleteModal();
      } else {
        toast.error(response?.message);
      }
    });
  };

  const HandleUpdateProfile = (data) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_profile + `?userId=${data?.user?.id}`;
    setPageStates((prevStates) => ({
      ...prevStates,
      loadingProfile: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prevStates) => ({
        ...prevStates,
        loadingProfile: false,
      }));
      if (response?.status === true) {
        navigate(RoutesLink?.update_profile, {
          state: { data: response?.data },
        });
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "empName", label: "Emp. Name" },
    { value: "empDept", label: "Emp. Dept." },
    { value: "empDesignation", label: "Designation" },
    { value: "phone", label: "Phone" },
    { value: "shift", label: "Shift" },
    { value: "status", label: "Status" },
  ];

  const ActionData = [
    ...(userDetails?.designation?.name === "Plant Head"
      ? [
        {
          label: "Update Profile",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "Update Profile",
          clickHandler: HandleUpdateProfile,
        },
      ]
      : []),
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "View Profile",
      clickHandler: HandleViewUser,
    },
  ];

  function filterEmployeeData(data) {
    const SeniorEmployee = data?.[0]?.seniorEmployee;
    const childrens = data?.[0]?.juniorEmployees?.map((jn) => ({
      ...jn,
      id: jn?.id,
      designation: jn?.juniorEmployee?.designation?.name,
      name: jn?.juniorEmployee?.name,
    }));
    const result = {
      id: SeniorEmployee?.id,
      designation: SeniorEmployee?.designation?.name,
      name: SeniorEmployee?.name,
      childrens: childrens,
    };

    const processChildren = (childrens) => {
      return childrens?.map((ch) => {
        // Find the matching senior employee for the current child
        const matchingSenior = data?.find(
          (dd) => dd.seniorEmployee?.id === ch?.juniorEmployee?.id
        );
        if (matchingSenior) {
          // Add matching senior employee data to the child
          ch.childrens = matchingSenior?.juniorEmployees?.map((jun) => ({
            ...jun,
            id: jun?.id,
            designation: jun?.juniorEmployee?.designation?.name,
            name: jun?.juniorEmployee?.name,
          }));
          ch.seniorEmployeeData = matchingSenior.seniorEmployee;
        }
        if (ch.childrens && ch.childrens.length > 0) {
          ch.childrens = processChildren(ch.childrens);
        }

        return ch;
      });
    };
    result.childrens = processChildren(childrens);
    return result;
  }

  const formattedData = filterEmployeeData(pageStates?.siteTeamList);

  const GetGrandTotal = () => {
    let newGrandTotal = 0;
    budgetSection.forEach((expense) => {
      newGrandTotal += expense.budgetTotal;
    });
    return newGrandTotal;
  };
  const GetFreezedGrandTotal = () => {
    let newFreezedGrandTotal = 0;
    budgetSection.forEach((expense) => {
      newFreezedGrandTotal += expense.freezedBudgetTotal;
    });
    return newFreezedGrandTotal;
  };
  const GetRemainingGrandTotal = () => {
    let newRemainingGrandTotal = 0;
    budgetSection.forEach((expense) => {
      newRemainingGrandTotal += expense.remainingBudgetTotal;
    });
    return newRemainingGrandTotal;
  };

  const handleExport = () => {
    let filterData = {
      exportDataType: "siteBudget",
      siteId: pageStates?.siteDetail?.id,
      financialYear: pageStates?.activeFinancialYear,
    };
    ExportDataHandler(filterData);
  };

  return (
    <>
      <>
        {(pageStates?.loadingProfile ||
          pageStates?.loadingBudget ||
          pageStates?.loadingSiteDetail) && <BgBlurLoader />}
        <div className="content container-fluid">
          <MainHeading title="Site Detail" showBackButton={true} />
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <Nav tabs className="nav nav-tabs border-0 mb-4">
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 1
                        ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                        : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(1)}
                  >
                    Site Details
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 2
                        ? "btn btn-outline-primary px-5 rounded-0 border-end-0 border-start-0 active"
                        : "btn btn-outline-primary px-5 rounded-0 border-end-0 border-start-0"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(2)}
                  >
                    Site Budgets
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 3
                        ? "btn btn-outline-primary px-5 rounded-0 border-end-0 border-start-0 active"
                        : "btn btn-outline-primary px-5 rounded-0 border-end-0 border-start-0"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(3)}
                  >
                    Team
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 4
                        ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                        : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(4)}
                  >
                    Budget Analytics
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            {ActiveTab === 2 && (
              <div className=" mb-3 d-flex justify-content-end gap-2">
                <button className="btn btn-outline-primary" onClick={handleExport}>
                  Export
                </button>
                <select
                  style={{ width: "200px" }}
                  className="form-select fw-semibold"
                  value={pageStates?.activeFinancialYear}
                  onChange={(e) =>
                    setPageStates({ ...pageStates, activeFinancialYear: e.target.value })
                  }
                >
                  {pageStates?.financialYears?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <TabContent activeTab={ActiveTab}>
            <TabPane tabId={1}>
              <Fade in={ActiveTab === 1} timeout={200}>
                <div className="card manage-user-list">
                  <div className="card-body">
                    <h3>Site Location</h3>
                    <MapComponent
                      apiKey={apiKey}
                      center={mapCenter}
                      markers={markers}
                      circleRadius={circleRadius || 0}
                    />
                    <ul className="row list-unstyled mt-4">
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Site Name :-
                          </span>
                          {pageStates?.siteDetail?.name || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Site Code :-
                          </span>
                          {pageStates?.siteDetail?.code || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Company :-
                          </span>
                          {pageStates?.siteDetail?.Company?.name || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Customer :-
                          </span>
                          {pageStates?.siteDetail?.customer?.name || "--"}
                        </p>
                      </li>

                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Customer Email :-
                          </span>
                          {pageStates?.siteDetail?.customer?.email || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Customer Company Name :-
                          </span>
                          {pageStates?.siteDetail?.customercompany
                            ?.companyName || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Start Date :-
                          </span>
                          {pageStates?.siteDetail?.startDate ? moment(pageStates?.siteDetail?.startDate).format("DD-MM-YYYY") : "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            End Date :-
                          </span>
                          {pageStates?.siteDetail?.endDate ? moment(pageStates?.siteDetail?.endDate).format("DD-MM-YYYY") : "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Salary Cycle Start Day :-
                          </span>
                          {pageStates?.siteDetail?.salaryCycleStartDay || "--"}
                        </p>
                      </li>
                    </ul>
                    <ul className="row list-unstyled">
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Address :-
                          </span>
                          {pageStates?.siteDetail?.address || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Latitude :-
                          </span>
                          {pageStates?.siteDetail?.location?.lat || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Longitude :-
                          </span>
                          {pageStates?.siteDetail?.location?.lng || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Range(in mtr) :-
                          </span>
                          {pageStates?.siteDetail?.range || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            Capacity(in MW) :-
                          </span>
                          {pageStates?.siteDetail?.Mw || "--"}
                        </p>
                      </li>
                      <li className="col-12 col-md-6 col-lg-4">
                        <p>
                          <span className="text-muted fs-5 d-block">
                            State :-
                          </span>
                          {pageStates?.siteDetail?.state || "--"}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 ">
                    <div className="card manage-user-list">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                          <h4 className="d-flex align-items-center mb-4">
                            Documents
                          </h4>
                        </div>
                        <ul className="row list-unstyled gap-3">
                          {pageStates?.siteDetail?.documents?.length > 0 ? (
                            pageStates?.siteDetail?.documents?.map((item) => {
                              const fileExtension = item?.url
                                ?.split("-")
                                ?.pop()
                                ?.split(".")
                                ?.pop()
                                ?.toLowerCase();

                              return (
                                <li
                                  className="col-12"
                                  role="button"
                                  key={item?.url}
                                  onClick={() => handleDocumentClick(item)}
                                >
                                  <div className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100">
                                    <span className="d-flex align-items-center gap-2">
                                      <DocumentIcon />
                                      {item?.url?.split("-")?.pop()}
                                    </span>
                                    <span className="fs-6">
                                      {item?.updatedAt ? moment(item?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                                    </span>
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            <div>
                              <h4>No Documents Found</h4>
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={2}>
              <Fade in={ActiveTab === 2} timeout={200}>

                <div className="d-flex align-items-center justify-content-center gap-2 px-3 py-2 mb-3 rounded-4" style={{ backgroundColor: "#fff1f2", border: "1px solid #ffe4e6" }}>
                  <i className="bi bi-info-circle-fill" style={{ color: "#e11d48", fontSize: "16px" }}></i>
                  <div className="fs-4" style={{ color: "#9f1239" }}>
                    <strong className="fw-bold">Note:</strong> All budget amounts are exclusive of GST.
                  </div>
                </div>

                {/* Top Amount Summary Cards */}
                <div className="row g-3 mb-4">
                  <div className="col-12 col-md-4">
                    <div className="card shadow-sm border border-light rounded-4 h-100">
                      <div className="card-body p-4 d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: "50px", height: "50px", backgroundColor: "#e0ebff", color: "#0d6efd" }}>
                          <i className="bi bi-wallet fs-4"></i>
                        </div>
                        <div>
                          <div className="text-muted fw-semibold mb-1" style={{ fontSize: "13px" }}>Total Budget</div>
                          <h4 className="fw-bold text-primary mb-1">{formatAmount(GetGrandTotal())}</h4>
                          <div className="text-muted small">Total expected amount</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="card shadow-sm border border-light rounded-4 h-100">
                      <div className="card-body p-4 d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: "50px", height: "50px", backgroundColor: "#fef3c7", color: "#d97706" }}>
                          <i className="bi bi-lock-fill fs-4"></i>
                        </div>
                        <div>
                          <div className="text-muted fw-semibold mb-1" style={{ fontSize: "13px" }}>Frozen Amount</div>
                          <h4 className="fw-bold text-danger mb-1">{formatAmount(GetFreezedGrandTotal())}</h4>
                          <div className="text-muted small">Total frozen amount</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="card shadow-sm border border-light rounded-4 h-100">
                      <div className="card-body p-4 d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: "50px", height: "50px", backgroundColor: "#dcfce7", color: "#16a34a" }}>
                          <i className="bi bi-wallet-fill fs-4"></i>
                        </div>
                        <div>
                          <div className="text-muted fw-semibold mb-1" style={{ fontSize: "13px" }}>Remaining Amount</div>
                          <h4 className="fw-bold text-success mb-1">{formatAmount(GetRemainingGrandTotal())}</h4>
                          <div className="text-muted small">Total available amount</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Accordion open={open} toggle={toggle}>
                  {budgetSection && budgetSection.length > 0 ? (
                    budgetSection.map((budget, budgetIndex) => {
                      let themeStyle = { backgroundColor: "#e0ebff", color: "#0d6efd" }; // primary
                      let iconClass = "bi-bag";
                      if (budget?.heading?.includes("Supply")) { themeStyle = { backgroundColor: "#dcfce7", color: "#16a34a" }; iconClass = "bi-box-seam"; }
                      else if (budget?.heading?.includes("Staff")) { themeStyle = { backgroundColor: "#fef3c7", color: "#d97706" }; iconClass = "bi-people"; }
                      else if (budget?.heading?.includes("General")) { themeStyle = { backgroundColor: "#f3e8ff", color: "#9333ea" }; iconClass = "bi-bank"; }

                      return (
                        <AccordionItem key={budgetIndex} className="mb-3 border border-light rounded-3 shadow-sm overflow-hidden bg-white">
                          {/* Main Accordion Header */}
                          <AccordionHeader
                            targetId={budgetIndex.toString()}
                            className="py-1"
                          >
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center w-100 pe-2 gap-3">
                              <div className="d-flex align-items-center gap-3">
                                <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: "48px", height: "48px", ...themeStyle }}>
                                  <i className={`bi ${iconClass} fs-4`}></i>
                                </div>
                                <div>
                                  <span className="fs-4 fw-bold text-dark d-block mb-1">
                                    {budget?.heading}
                                  </span>
                                  <span className="text-muted small fw-medium">
                                    {budget?.budgetItems?.length || 0} Budget Heads
                                  </span>
                                </div>
                              </div>
                              <div className="d-flex gap-4 gap-md-5 mt-3 mt-md-0 me-md-4">
                                <div className="text-center">
                                  <span className="text-muted small fw-semibold d-block mb-1">Expected</span>
                                  <span className="fw-bold text-primary" style={{ fontSize: "15px" }}>{formatAmount(budget?.budgetTotal)}</span>
                                </div>
                                <div className="text-center">
                                  <span className="text-muted small fw-semibold d-block mb-1">Frozen</span>
                                  <span className="fw-bold text-danger" style={{ fontSize: "15px" }}>{formatAmount(budget?.freezedBudgetTotal)}</span>
                                </div>
                                <div className="text-center">
                                  <span className="text-muted small fw-semibold d-block mb-1">Remaining</span>
                                  <span className="fw-bold text-success" style={{ fontSize: "15px" }}>{formatAmount(budget?.remainingBudgetTotal)}</span>
                                </div>
                              </div>
                            </div>
                          </AccordionHeader>

                          {/* Main Accordion Body */}
                          <AccordionBody accordionId={budgetIndex.toString()} className="p-0 border-top border-light">
                            {budget?.budgetItems && budget?.budgetItems.length > 0 ? (
                              <div className="bg-white">
                                {/* Table Header */}
                                <div className="d-none d-md-flex row align-items-center bg-light border-bottom border-light py-2 px-4 m-0 text-muted fw-semibold" style={{ fontSize: "13px" }}>
                                  <div className="col-3">Budget Head</div>
                                  <div className="col-4">Description</div>
                                  <div className="col-5">
                                    <div className="row">
                                      <div className="col-4 text-center">Expected</div>
                                      <div className="col-4 text-center">Frozen</div>
                                      <div className="col-4 text-center">Remaining</div>
                                    </div>
                                  </div>
                                </div>

                                {/* Table Rows */}
                                {budget?.budgetItems.map((item, itemIndex) => (
                                  <div
                                    key={itemIndex}
                                    className={`row align-items-center py-3 px-4 m-0 ${itemIndex !== budget?.budgetItems.length - 1 ? 'border-bottom border-light' : ''}`}
                                  >
                                    {/* Budget Head */}
                                    <div className="col-12 col-md-3 mb-2 mb-md-0 d-flex align-items-center gap-3">
                                      <div className="d-flex align-items-center justify-content-center rounded" style={{ width: "36px", height: "36px", ...themeStyle }}>
                                        <i className="bi bi-grid"></i>
                                      </div>
                                      <span className="fw-bold text-dark fs-5" style={{ wordBreak: 'break-word' }}>
                                        {budget?.type === "staffBudget"
                                          ? item?.department?.name
                                          : item?.expensehead?.name || "--"}
                                      </span>
                                    </div>

                                    {/* Description */}
                                    <div className="col-12 col-md-4 mb-3 mb-md-0 pe-md-4">
                                      <ExpandableDescription
                                        text={item?.description}
                                        onReadMore={(text) => setDescModal({ isOpen: true, text })}
                                      />
                                    </div>

                                    {/* Amounts */}
                                    <div className="col-12 col-md-5">
                                      <div className="row align-items-center">
                                        <div className="col-4 text-center">
                                          <span className="d-md-none text-muted small fw-semibold d-block mb-1">Expected</span>
                                          <span className="fw-bold fs-5 text-primary">{formatAmount(item?.expectedAmount)}</span>
                                        </div>
                                        <div
                                          className="col-4 text-center"
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedFreezedItem(item);
                                            if ((parseFloat(item?.freezedAmount) || 0) + (parseFloat(item?.cashflowAmount) || 0) > 0) {
                                              toggleFreezedModal();
                                            } else {
                                              toast.error("No freezed amount found");
                                            }
                                          }}
                                        >
                                          <span className="d-md-none text-muted small fw-semibold d-block mb-1">Frozen</span>
                                          <span className="fw-bold fs-5 text-danger">{formatAmount(Math.max(parseFloat(item?.freezedAmount) || 0, parseFloat(item?.cashflowAmount) || 0))}</span>                                        </div>
                                        <div className="col-4 text-center">
                                          <span className="d-md-none text-muted small fw-semibold d-block mb-1">Remaining</span>
                                          <span className="fw-bold fs-5 text-success">{formatAmount(parseFloat(item?.expectedAmount || 0) - Math.max(parseFloat(item?.freezedAmount) || 0, parseFloat(item?.cashflowAmount) || 0))}</span>                                        </div>
                                      </div>
                                    </div>

                                    {/* Render Designations for Staff Budget */}
                                    {budget?.type === "staffBudget" && item?.sitebudgetitems?.length > 0 && (
                                      <div className="col-12 mt-3 ps-md-5 border-start border-2 border-warning">
                                        <div className="table-responsive">
                                          <table className="table table-sm table-borderless m-0 text-muted" style={{ fontSize: "13px" }}>
                                            <thead>
                                              <tr className="border-bottom border-light fw-semibold">
                                                <th>Designation</th>
                                                <th className="text-center">Qty</th>
                                                <th className="text-center">Month</th>
                                                <th className="text-center">Rate</th>
                                                <th className="text-center">Expected</th>
                                                <th className="text-center">Frozen</th>
                                                <th className="text-center">Remaining</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.sitebudgetitems.map((sbItem, sbIndex) => {
                                                const expected = parseFloat(sbItem?.total || sbItem?.amount || "0");
                                                const frozen = (parseFloat(sbItem?.freezedAmount) || 0) + (parseFloat(sbItem?.cashflowAmount) || 0);
                                                const remaining = expected - frozen;
                                                return (
                                                  <tr key={sbIndex}>
                                                    <td className="fw-semibold text-dark">{sbItem?.designation?.name || sbItem?.designationName || "--"}</td>
                                                    <td className="text-center">{sbItem?.quantity ?? "--"}</td>
                                                    <td className="text-center">{sbItem?.month ?? "--"}</td>
                                                    <td className="text-center">{formatAmount(sbItem?.unitRate || sbItem?.rate || 0)}</td>
                                                    <td className="text-center fw-bold text-primary">{formatAmount(expected)}</td>
                                                    <td className="text-center fw-bold text-danger">{formatAmount(frozen)}</td>
                                                    <td className="text-center fw-bold text-success">{formatAmount(remaining)}</td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center fw-medium py-4 text-muted d-flex flex-column align-items-center bg-light">
                                <NoRecordIcon className="mb-2" />
                                <span className="fs-5">No Budget Data Found</span>
                              </div>
                            )}
                          </AccordionBody>
                        </AccordionItem>
                      );
                    })
                  ) : (
                    <div className="text-center fw-medium py-4 text-muted d-flex flex-column align-items-center bg-light rounded-3 border">
                      <NoRecordIcon className="mb-2" />
                      <span className="fs-5">No Budget Data Found</span>
                    </div>
                  )}
                </Accordion>

              </Fade>
            </TabPane>
            <TabPane tabId={3}>
              <Fade in={ActiveTab === 3} timeout={200}>
                <div className="d-flex align-items-start justify-content-between">
                  <ul
                    className="nav nav-tabs border-0 mb-3"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="btn btn-outline-primary px-5 rounded-0 rounded-start-2 border-end-0 active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#four"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="false"
                        tabIndex={-1}
                      >
                        All Members
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="btn btn-outline-primary px-5 rounded-0 rounded-end-2 border-start-0 "
                        id="contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#five"
                        type="button"
                        role="tab"
                        aria-controls="contact-tab-pane"
                        aria-selected="true"
                      >
                        Site Team
                      </button>
                    </li>
                  </ul>
                  {(checkUserAccess(userDetails).isUserAccess ||
                    userDetails?.designation?.name === "Plant Head") && (
                      <button
                        className="btn btn-outline-primary px-5"
                        type="button"
                        onClick={() => toggleAddTeamModal()}
                      >
                        <span>
                          <PlusIcon />
                        </span>
                        Add Team
                      </button>
                    )}
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="four"
                        role="tabpanel"
                        aria-labelledby="pills-DailyAttendance-tab"
                        tabIndex={0}
                      >
                        <FilterComponent handleSearch={handleSearchChange} />
                        <CommonTable
                          TableHeading={TableHeading}
                          TableData={pageStates?.siteUsersList}
                          ActionData={ActionData}
                          currentPage={pageStates?.currentPage}
                          PageChangeHandler={PageChangeHandler}
                          isLoading={pageStates?.tableLoader}
                          totalPages={pageStates?.totalPages}
                          count={pageStates?.count}
                          handleChangePageSize={handleChangePageSize}
                          pageSize={pageStates.pageSize}
                        />
                      </div>
                      <div
                        className="tab-pane fade"
                        id="five"
                        role="tabpanel"
                        aria-labelledby="pills-MonthlyAttendance-tab"
                        tabIndex={0}
                      >
                        <div className="">
                          {pageStates?.siteTeamList?.length > 0 ? (
                            <TeamTree
                              data={formattedData}
                              onDelete={DeleteActionHandler}
                            />
                          ) : (
                            <div className="text-muted text-center py-5">
                              No Team Created Yet !{" "}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={4}>
              <Fade in={ActiveTab === 4} timeout={200}>
                {budgetAnalyticsSummary ? (
                  <div className="budget-analytics-dashboard mt-3">
                    <div className="row g-3 mb-4">
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="card shadow-sm h-100 rounded-3" style={{ backgroundColor: '#eef2ff', color: '#312e81', border: '1px solid #c7d2fe' }}>
                          <div className="card-body p-3">
                            <div className="small fw-semibold text-uppercase mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Revised Budget</div>
                            <h4 className="mb-0 fw-bold">{formatAmount(budgetAnalyticsSummary.revisedBudget)}</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="card shadow-sm h-100 rounded-3" style={{ backgroundColor: '#faf5ff', color: '#6b21a8', border: '1px solid #e9d5ff' }}>
                          <div className="card-body p-3">
                            <div className="small fw-semibold text-uppercase mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Committed (POs)</div>
                            <h4 className="mb-0 fw-bold">{formatAmount(budgetAnalyticsSummary.committed)}</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg">
                        <div className="card shadow-sm h-100 rounded-3" style={{ backgroundColor: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0' }}>
                          <div className="card-body p-3">
                            <div className="small fw-semibold text-uppercase mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Actual Spent</div>
                            <h4 className="mb-0 fw-bold">{formatAmount(budgetAnalyticsSummary.actualSpent || 0)}</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg">
                        <div className="card shadow-sm h-100 rounded-3" style={{ backgroundColor: '#fff5f5', color: '#9b2c2c', border: '1px solid #fed7d7' }}>
                          <div className="card-body p-3">
                            <div className="small fw-semibold text-uppercase mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>GST Committed</div>
                            <h4 className="mb-0 fw-bold">{formatAmount(budgetAnalyticsSummary.gstCommitted || 0)}</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg">
                        <div className="card shadow-sm h-100 rounded-3" style={{ backgroundColor: '#f7fee7', color: '#3f6212', border: '1px solid #d9f99d' }}>
                          <div className="card-body p-3">
                            <div className="small fw-semibold text-uppercase mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Available</div>
                            <h4 className="mb-0 fw-bold">{formatAmount(budgetAnalyticsSummary.available)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 border-bottom pb-2">
                      {["All", "Supply budget", "Service budget", "General budget", "Staff budget"].map((filter) => (
                        <button
                          key={filter}
                          className={`btn rounded-pill px-4 py-1 me-2 mb-2 ${budgetFilter === filter ? 'btn-primary text-white shadow-sm fw-semibold' : 'btn-light bg-white text-muted border'}`}
                          style={{ fontSize: '14px' }}
                          onClick={() => setBudgetFilter(filter)}
                        >
                          {filter}
                        </button>
                      ))}
                    </div>

                    <div className="budget-heads-list">
                      {budgetAnalyticsHeads
                        .filter(head => {
                          if (budgetFilter === "All") return true;
                          const headType = (head?.type || "").toLowerCase().replace(/\s/g, '');
                          const filterType = budgetFilter.toLowerCase().replace(/\s/g, '');
                          return headType === filterType;
                        })
                        .map((head, idx) => {
                          const rbNum = parseFloat(head.rb || 0);
                          const actualNum = parseFloat(head.actual || 0);
                          const committedNum = parseFloat(head.committed || 0);
                          const availableNum = parseFloat(head.available || 0);

                          const actualPct = rbNum ? (actualNum / rbNum) * 100 : 0;
                          const committedPct = rbNum ? (committedNum / rbNum) * 100 : 0;
                          const availablePct = rbNum ? (availableNum / rbNum) * 100 : 100;

                          return (
                            <div className="card shadow-sm mb-4 border rounded-3" key={head.id || idx} style={{ borderColor: '#d1d5db' }}>
                              <div className="card-body p-4">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                  <div className="d-flex align-items-center gap-3">
                                    <h5 className="mb-0 fw-bold text-dark">{head.headName || "--"}</h5>
                                    <span className="badge rounded-pill fw-medium" style={{ backgroundColor: '#e0f2f1', color: '#00695c' }}>
                                      {head.type || "--"}
                                    </span>
                                  </div>
                                  <div>
                                    <span className="fs-5 fw-bold" style={{ color: '#047857' }}>{formatAmount(head.rb)} RB</span>
                                  </div>
                                </div>

                                <div className="row text-center mb-4">
                                  <div className="col border-end border-light">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>OB</div>
                                    <div className="fw-semibold text-dark">{formatAmount(head.ob)}</div>
                                  </div>
                                  <div className="col border-end border-light">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Revisions</div>
                                    <div className="fw-semibold text-warning">{formatAmount(head.revisions)}</div>
                                  </div>
                                  <div className="col border-end border-light">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>RB</div>
                                    <div className="fw-semibold text-success">{formatAmount(head.rb)}</div>
                                  </div>
                                  <div className="col border-end border-light">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Committed</div>
                                    <div className="fw-semibold" style={{ color: '#6366f1' }}>{formatAmount(head.committed)}</div>
                                  </div>
                                  <div className="col border-end border-light">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Actual</div>
                                    <div className="fw-semibold" style={{ color: '#0ea5e9' }}>{formatAmount(head.actual)}</div>
                                  </div>
                                  <div className="col border-end border-light">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>GST Committed</div>
                                    <div className="fw-semibold text-danger">{formatAmount(head.gstCommitted || 0)}</div>
                                  </div>
                                  <div className="col">
                                    <div className="text-muted small text-uppercase fw-semibold mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Available</div>
                                    <div className="fw-semibold text-dark">{formatAmount(head.available)}</div>
                                  </div>
                                </div>

                                <div className="progress rounded-pill mb-2" style={{ height: '6px', backgroundColor: '#f3f4f6' }}>
                                  <div className="progress-bar" style={{ width: `${actualPct}%`, backgroundColor: '#059669' }}></div>
                                  <div className="progress-bar" style={{ width: `${committedPct}%`, backgroundColor: '#6366f1' }}></div>
                                  <div className="progress-bar" style={{ width: `${availablePct}%`, backgroundColor: '#e5e7eb' }}></div>
                                </div>

                                <div className="d-flex gap-3 small mt-3">
                                  <div className="d-flex align-items-center text-muted" style={{ fontSize: '12px' }}>
                                    <span className="d-inline-block rounded-1 me-2" style={{ width: '8px', height: '8px', backgroundColor: '#059669' }}></span>
                                    Actual spent
                                  </div>
                                  <div className="d-flex align-items-center text-muted" style={{ fontSize: '12px' }}>
                                    <span className="d-inline-block rounded-1 me-2" style={{ width: '8px', height: '8px', backgroundColor: '#6366f1' }}></span>
                                    Committed
                                  </div>
                                  <div className="d-flex align-items-center text-muted" style={{ fontSize: '12px' }}>
                                    <span className="d-inline-block rounded-1 me-2" style={{ width: '8px', height: '8px', backgroundColor: '#e5e7eb' }}></span>
                                    Available
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                      {budgetAnalyticsHeads.filter(head => {
                        if (budgetFilter === "All") return true;
                        const headType = (head?.type || "").toLowerCase().replace(/\s/g, '');
                        const filterType = budgetFilter.toLowerCase().replace(/\s/g, '');
                        return headType === filterType;
                      }).length === 0 && (
                          <div className="text-center py-5 text-muted border rounded-3 bg-light">
                            <p className="mb-0">No budget heads found for the selected filter.</p>
                          </div>
                        )}
                    </div>
                  </div>
                ) : (
                  <div className="text-center fw-medium py-5 text-muted d-flex flex-column align-items-center">
                    <NoRecordIcon className="mb-2" />
                    <span className="fs-5">No Budget Analytics Data Found</span>
                  </div>
                )}
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      <AddTeamModal
        modal={addTeamModal}
        toggle={toggleAddTeamModal}
        siteId={id}
        GetSiteTeam={GetSiteTeam}
      />
      <ConfirmModal
        modal={deleteModal}
        toggle={toggleDeleteModal}
        submitHandler={handleDeleteTeamMember}
        isLoading={isLoading}
      />
      <FreezedAmountDetailModal
        isOpen={isFreezedModalOpen}
        toggle={toggleFreezedModal}
        selectedItem={selectedFreezedItem}
      />
      <Modal isOpen={descModal.isOpen} toggle={toggleDescModal} centered size="md">
        <ModalHeader toggle={toggleDescModal}>Description</ModalHeader>
        <ModalBody>
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }} className="text-secondary fs-5">
            {descModal.text}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
